import { render, staticRenderFns } from "./ImprintLinks.vue?vue&type=template&id=58466ae1&scoped=true"
import script from "./ImprintLinks.vue?vue&type=script&lang=js"
export * from "./ImprintLinks.vue?vue&type=script&lang=js"
import style0 from "./ImprintLinks.vue?vue&type=style&index=0&id=58466ae1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58466ae1",
  null
  
)

export default component.exports